<template>
	<div class="aboutus-page">
	<div class="aboutus-pic"><img src="../common/images/aboutUs-img-1.jpg" alt="和数传媒-链接未来"></div>
	<div class="aboutus-content b-shadow">
      <ul class="tabList">
        <li @click='tabs("aboutUs")' :class='{active:current == "aboutUs"}'>关于我们</li>
        <li @click='tabs("service")' :class='{active:current == "service"}'>服务内容</li>
        <li @click='tabs("contcat")' :class='{active:current == "contcat"}'>联系我们</li>
      </ul>
      <div class="content">
        <div class="about tab-cont" :class='{active:current == "aboutUs"}'>
            <h3>关于和数</h3>
            <div class="text-box">
              和数传媒（heshumedia.com），全球最新科技资讯发布平台，每日持续更新报道IT业界、互联网、区块链、人工智能、AI等技术及产品资讯新闻，是最及时权威的产业新闻及硬件新闻报道平台，致力于挖掘世界价值，传递积极、真实的价值观和信息能量，去伪存真，精准分析行业全球最新资讯，构建和谐发展的科技生态圈。
            </div>
            <h3>总经理寄语</h3>
            <div class="text-box">
              <img src="../common/images/aboutUs-img-2.jpg" alt="">
              <div class="text">李思齐女士表示：作为一个优秀的媒体人，要以最朴素的情怀，用担当和责任完成这个时代级的命题，弘扬正面价值观，形成品牌美誉度，达成公信力。针砭时弊，寻求真理和真相，辩识价值是我们的第一要务。新科技技术领域，它像婴儿般稚嫩，需要呵护，同时，它又是那样的顽强，茁壮成长，以不可逆的态势，像爱迪生发明的电一样，点燃全世界！这是一场只有起点，没有终点的全球接力赛，面对这个新兴产业的崛起，我们选择护航和推动，因为所到之处都是创造，都是提升效率、降低成本、共识、共享，它将改变世界，造福全人类！</div>
            </div>
        </div>
        <div class="service tab-cont" :class='{active:current == "service"}'>
          <h3>业务范畴</h3>
          <ul>
            <li>新闻报道：专注人工智能、AI、区块链等新科技，报道全球一手新闻资讯。</li>
            <li>行业峰会：承办、协办行业峰会，提供线下交流平台。</li>
            <li>人物专访：对新科技行业有影响力人士进行深度报道。</li>
            <li>行业专栏：聚焦行业观点，业界著名学者和专家犀利点评。</li>
          </ul>
          <h3>核心特色</h3>
          <ul>
            <li>深度文章：深度采访，实时报道一线资讯。</li>
            <li>覆盖面广：覆盖全球，国内外要闻早知道。</li>
            <li>精准解读：精选内容，学者大咖多维度解读。</li>
            <li>全方位传播：全网推广，构建立体交互的全媒体覆盖传播模式。</li>
          </ul>
          <h3>核心特色</h3>
          <ul>
            <li>宣传策略：大数据精选匹配，聚焦优质资源影响力。</li>
            <li>宣传形式：深度文章、图文展示、视频播放，传播迅速，轻松曝光。</li>
            <li>宣传价值：联合区块链媒体资源，宣传力度强大，迅速渗透整个科技行业。</li>
          </ul>
        </div>
        <div class="contact tab-cont" :class='{active:current == "contcat"}'>
          <div class="info">
            <p>电话：4001101815</p>
            <p>邮箱： contact@heshumedia.com</p>
            <p>地址：深圳市龙华新区民治大道优城商务大厦B座1308</p>
            <p>邮编：518000</p>
          </div>
          <div class="ewm"><img src="../common/images/ewm.jpg" alt="二维码"><p>（微信公众号二维码）</p></div>
        </div> 
      </div>
   </div>
   </div>
</template>

<script>
	export default {
		created () {
			this.current = this.$route.params.aboutkey;
		},
		data () {
			return {
				current: "aboutUs"
			}
		},
		methods: {
			tabs (item) {
				this.current = item;
			}
		},
		watch: {
	    	'$route' (to, from) {
			 	this.current = this.$route.params.aboutkey;
			}
	    }
	}
</script>
<style lang="scss">
.aboutus-page{
	.aboutus-pic{
		margin-bottom:.2rem;
	}
	.aboutus-content{
		min-height:450px;
	}
	.tabList{
		height: .7rem;
		line-height:.7rem;
		border-bottom:1px solid #f29316;
		padding-left: .3rem;
		box-sizing: border-box;
		li{
			float: left;
			font-size: .3rem;
			margin-right:.5rem;
			&.active{
				color: #f29316;
			}
		}
	}
	.tab-cont {
		padding:.4rem .3rem;
		display: none;
		&.active{
			display: block;
		}
		h3{
			font-size:.3rem;
			color: #f29316;
			margin-bottom: .2rem;
		}
		.text-box{
			margin-bottom: .3rem;
			line-height: .36rem;
			color: #333;
			&:last-child{
				margin-bottom:0;
			}
			img{
				width: 100%;
				margin-bottom:.15rem;
			}
			.text{
				text-indent: .4rem;
			}
		}
	}
	.service {
		ul{
			margin-bottom:.3rem;
		}
		li{
			padding-left: .3rem;
			background:url("../common/images/aboutus-page.png") no-repeat;
			background-size: .12rem .13rem;
			background-position: .08rem .1rem;
			line-height: .36rem;
			color: #333;
			margin-bottom:.1rem;
		}
	}
	.contact {
		padding:2rem .3rem;
		text-align:center;
		color: #363636;
		.info{
			margin-bottom:.7rem;
			p{
				margin-bottom: .2rem;
			}
		}
		.ewm img{
			width: 1.73rem;
		}
		.ewm p{
			margin-top:.2rem;
		}
	}
}
.appPage{
	.aboutus-pic{
		margin-bottom: 0;
	}
	.tabList{
		display: none;
	}
} 
</style>


// WEBPACK FOOTER //
// src/page/aboutView.vue